@if (note) {
  <div class="note">
    <div class="body">
      <div class="made-by button-text">{{ note.author }}</div>
      @if (isEditing) {
        <div>
          <app-staff-journal-note-input [note]="note" (cancel)="onCancel()" (save)="onSave($event)" labelText="Edit note" />
        </div>
      }
      @if (!isEditing) {
        <div class="content body-text">{{ note.body }}</div>
      }
      @if (!isEditing) {
        <div class="footer">
          <div class="edited">
            {{ noteDate }}
            @if (note.edited) {
              <span>&nbsp;(edited)</span>
            }
          </div>
          <div>
            @if (note.isEditable) {
              <button (click)="onDelete()" mat-button>Delete</button>
            }
            @if (note.isEditable) {
              <button (click)="onEdit()" mat-button>Edit</button>
            }
          </div>
        </div>
      }
    </div>
  </div>
}
